import requests from "../requests";

export default {
  list(showIgnored, showHandled, showCancelled) {
    return requests.get(
      `enquiries?show_ignored=${showIgnored}&show_handled=${showHandled}&show_cancelled=${showCancelled}`,
    );
  },
  get(id) {
    return requests.get(`enquiries/${id}`);
  },
  create(obj) {
    return requests.post(`enquiries`, obj);
  },
  update(obj) {
    return requests.put(`enquiries/${obj.id}`, obj);
  },
  delete(obj) {
    return requests.delete(`enquiries/${obj.id}`);
  },
  activate(obj, data) {
    return requests.put(`enquiries/${obj.id}/activate`, data);
  },
  ignore(obj) {
    return requests.put(`enquiries/${obj.id}/ignore`);
  },
  restore(obj) {
    return requests.delete(`enquiries/${obj.id}/ignore`);
  },
  reassign(obj, data) {
    return requests.put(`enquiries/${obj.id}/assignment`, data);
  },
  mark_contacted(obj) {
    return requests.post(`enquiries/${obj.id}/contact`);
  },
  mark_handled(obj, data) {
    return requests.post(`enquiries/${obj.id}/handle`, data);
  },
  mark_cancelled(obj, data) {
    return requests.post(`enquiries/${obj.id}/cancel`, data);
  },
};
